/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { HelpTypeSite } from './HelpTypeSite'
import {
  HelpTypeSiteFromJSON,
  HelpTypeSiteFromJSONTyped,
  HelpTypeSiteToJSON,
} from './HelpTypeSite'
import type { HelpDataSite } from './HelpDataSite'
import {
  HelpDataSiteFromJSON,
  HelpDataSiteFromJSONTyped,
  HelpDataSiteToJSON,
} from './HelpDataSite'

/**
 *
 * @export
 * @interface GetHelpSiteRequest
 */
export interface GetHelpSiteRequest {
  /**
   * Тип внешней формы
   * @type {HelpTypeSite}
   * @memberof GetHelpSiteRequest
   */
  type: HelpTypeSite
  /**
   * Данные формы — поля зависят от конфигурации (динамическая валидация)
   * @type {HelpDataSite}
   * @memberof GetHelpSiteRequest
   */
  data: HelpDataSite
}

/**
 * Check if a given object implements the GetHelpSiteRequest interface.
 */
export function instanceOfGetHelpSiteRequest(
  value: object
): value is GetHelpSiteRequest {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetHelpSiteRequestFromJSON(json: any): GetHelpSiteRequest {
  return GetHelpSiteRequestFromJSONTyped(json, false)
}

export function GetHelpSiteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetHelpSiteRequest {
  if (json == null) {
    return json
  }
  return {
    type: HelpTypeSiteFromJSON(json['type']),
    data: HelpDataSiteFromJSON(json['data']),
  }
}

export function GetHelpSiteRequestToJSON(
  value?: GetHelpSiteRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    type: HelpTypeSiteToJSON(value['type']),
    data: HelpDataSiteToJSON(value['data']),
  }
}
